import request from "../request"
const server = {
    //新增、编辑收款账户
    addAccount: (params) => {
        return request.post('payment/supplier/addAccount', params)
    },
    //删除账户
    deleAccount: (params) => {
        return request.post('payment/supplier/deleAccount', params)
    },
    //收款账户列表
    payeeAccount: (params) => {
        return request.post('payment/supplier/payeeAccount', params)
    },
    //设置默认账户
    setDefaultAccount: (params) => {
        return request.post('payment/supplier/setDefaultAccount', params)
    },
    //获取地区信息 
    queryByParentId: (params) => {
        return request.post('user-center/area/queryByParentId', params)
    },
    //查询账户信息
    selBankAccountById: (params) => {
        return request.post('payment/supplier/selBankAccountById', params)
    },
    //根据银行卡号获取卡属银行(含校验)
    bankAccounts: (params) => {
        return request.post('payment/supplier/bankAccounts', params)
    }

}
export default server